import { FC } from 'react'
import { ServerTransactionStatusEnum } from '@expane/data'
import { InformationPopup } from 'widgets/InformationPopup'
import { IconType } from 'react-icons'
import { useTranslation } from 'react-i18next'
import {
  IoCheckmarkCircleSharp,
  IoCloseCircleSharp,
  IoHourglassOutline,
  IoTimeOutline,
} from 'react-icons/io5'

export const TransactionStatusIcon: FC<{ status: ServerTransactionStatusEnum }> = ({ status }) => {
  const { Icon, style, message } = useGetIcon(status)

  return (
    <InformationPopup CustomIcon={Icon} size="1.2rem" containerClassName={style}>
      {message}
    </InformationPopup>
  )
}

const useGetIcon = (
  status: ServerTransactionStatusEnum,
): { Icon: IconType; message: string; style?: string } => {
  const { t } = useTranslation()

  if (status === ServerTransactionStatusEnum.Completed)
    return {
      Icon: IoCheckmarkCircleSharp,
      message: t('transactionStatusHints.completed'),
      style: 'text-primary-500',
    }
  if (status === ServerTransactionStatusEnum.Pending) {
    return {
      Icon: IoTimeOutline,
      message: t('transactionStatusHints.pending'),
      style: 'text-warning-500',
    }
  }
  if (status === ServerTransactionStatusEnum.Failed) {
    return {
      Icon: IoCloseCircleSharp,
      message: t('transactionStatusHints.failed'),
      style: 'text-error-500',
    }
  }

  // status === ServerTransactionStatusEnum.Expired
  return {
    Icon: IoHourglassOutline,
    message: t('transactionStatusHints.expired'),
    style: 'text-gray-500',
  }
}
